import { useDispensaryChains } from './use-dispensary-chain';
import { useDispensaryChainsLazy } from './use-dispensary-chain-lazy';

export { useDispensaryChains, useDispensaryChainsLazy };
